export const CLASS_NAME = {
  SHOP_REGISTER: 'TutorABCShop註冊',
}
